import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'

export const TEXT_FR = {
  title: <>Le jeu de cartes des familles offshore</>,
  lead: (
    <>
      Rois, présidents, premiers ministres et leurs proches. Nous présentons ici
      seize personnalités politiques dont les entreprises offshore sont révélées
      dans les Pandora Papers - sous forme d'un sulfureux jeu de cartes.
    </>
  ),
  updated: <>Mis à jour le 3 octobre, 2021</>,
  credits: ['Analyse des données et texte', 'Visualisation'],
  intro: (
    <>
      <p>
        Un rapport de la Confédération le dit noir sur blanc: les personnalités
        politiques et leurs familles qui cachent des avoirs à l’étranger
        présentent un «risque particulièrement élevé». Dans les États
        autoritaires en particulier, les élites politiques mettent souvent la
        main sur des biens publics qui appartiennent en fait à la population du
        pays.
      </p>
      <p>
        Aujourd'hui, les fortunes colossales de plus de 300 personnalités
        politiquement exposées sont soudain révélées dans les Pandora Papers.
        Dans de nombreux cas, des intermédiaires en Suisse ont aidé à les
        dissimuler. Les sociétés offshore ne sont pas illégales en soi. Tout
        dépend de l'utilisation qui en est faite: d'où ces avoirs sont issus; et
        les raisons pour lesquelles ils sont cachés dans des sociétés boîtes aux
        lettres.
      </p>
      <p>
        Voici seize personnalités importantes, présentées sous forme de jeu de
        cartes.
      </p>
      <p>
        À faire vous-même: si vous voulez vraiment jouer à ce curieux jeux des
        familles, vous pouvez{' '}
        <Link href='https://dev-interaktiv.tagesanzeiger.ch/2021/xxxx-quartett/Pandora_Quartett_fr.pdf'>
          imprimer les cartes depuis ce pdf
        </Link>{' '}
        et les découper.
      </p>
    </>
  ),
  titleA: 'Rois et présidents',
  titleB: 'Ministres et premiers ministres',
  titleC: 'Une affaire de famille',
  titleD: 'Les éminences grises',
  textA: (
    <p>
      Trente-cinq chefs d'État actuels ou passés sont cités dans les Pandora
      Papers. Beaucoup d'entre eux ont promis de renoncer aux affaires et d’être
      transparents au moment de prendre leur fonction.
    </p>
  ),
  textB: (
    <p>
      Ces personnes gèrent les gigantesques budgets de l'État, contrôlent les
      recettes fiscales ou accordent des subventions – dans les Pandora Papers,
      plus de 300 hommes et femmes politiques et hauts fonctionnaires sont cités
      comme bénéficiaires de sociétés offshore.
    </p>
  ),
  textC: (
    <p>
      Il s'agit parfois de vastes clans familiaux, parfois d'une seule
      maîtresse. Les Pandora Papers montrent que les puissants doivent souvent
      s'occuper aussi de leurs proches.
    </p>
  ),
  textD: (
    <p>
      Les quatorze prestataires de services financiers figurant dans les Pandora
      Papers n'avaient pas que des célébrités pour clients. Des conseillers
      politiques, des responsables sportifs et des vice-ministres ont également
      créé des sociétés offshore. Cette arrière-garde n’est que très rarement
      sous les feux de la rampe.
    </p>
  )
}
